import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { TrelloClient } from '../../client';
export const TrelloClientContext = createContext(new TrelloClient());
export function TrelloClientProvider({ client, children }) {
    return (_jsx(TrelloClientContext.Provider, Object.assign({ value: client }, { children: children }), void 0));
}
export function useTrelloClient() {
    return useContext(TrelloClientContext);
}
//# sourceMappingURL=trello-client-context.js.map